export const DEFAULT_PLAN_ID = "gratuito";

type ResolvablePlan = { id: string; is_custom: boolean; assigned_org_id: string | null };

export function resolveCurrentPlan<P extends ResolvablePlan>(
  plans: readonly P[],
  orgPlanId: string | null | undefined,
  orgId: string | null | undefined,
): P | null {
  const ownPlan = orgPlanId ? plans.find((plan) => plan.id === orgPlanId) : undefined;
  if (ownPlan) return ownPlan;
  const assignedCustom = orgId ? plans.find((plan) => plan.is_custom && plan.assigned_org_id === orgId) : undefined;
  if (assignedCustom) return assignedCustom;
  return plans.find((plan) => plan.id === DEFAULT_PLAN_ID) ?? null;
}
